import PingAnimation from "components/PingAnimation/PingAnimation";

function PendingNotificationIcon({
  count,
  className,
  tooltipText,
  tooltipPosition,
  pingType,
}: {
  count: number;
  className?: string;
  tooltipText?: string;
  tooltipPosition?: string;
  pingType?: string;
}) {
  return (
    <div
      className={`flex relative ${className}`}
      data-pr-tooltip={tooltipText}
      data-pr-position={tooltipPosition}
    >
      <i
        className="pi pi-bell"
        style={{ fontSize: "1.5rem", color: "var(--bluegray-500)" }}
      />
      <PingAnimation count={count} position="absolute" pingType={pingType} />
    </div>
  );
}

export default PendingNotificationIcon;
